import { useState, useEffect } from "react";
import { useGetAllBatchesQuery } from "src/services/BatchServices";

const useBatches = () => {
  const [batches, setBatches] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const { data, isLoading, isFetching } = useGetAllBatchesQuery("");
  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setBatches(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);
  return { batches, isDataLoading };
};
export default useBatches;
